import chaletApi from "api/chaletApi";
import { ChaletApiResponse } from "types/ChaletApiResponse";
import { Driver, DriverWithUser } from "types/Driver";

const DeliveryDriverService = chaletApi.injectEndpoints({
  endpoints: (builder) => ({
    getDeliveryDrivers: builder.query<DriverWithUser[], void>({
      query: () => ({
        method: "GET",
        url: `/drivers/all`,
      }),
      transformResponse: (response: ChaletApiResponse<DriverWithUser[]>) => response.data,
    }),
    verifyDeliveryDriver: builder.mutation<Driver, number>({
      query: (id) => ({
        method: "PUT",
        url: `/drivers/${id}/verify`,
      }),
      transformResponse: (response: ChaletApiResponse<Driver>) => response.data,
    }),
  }),
  overrideExisting: true,
});

export default DeliveryDriverService;
